import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatApp } from 'cubedist-cube-pipeline-assistant-ui';
import { useAuth } from 'react-oidc-context';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useInlineFilterContext } from 'contexts/InlineFilters.context';
import { ChatbotContext } from 'contexts/Chatbot.context';
import { FeatureFlags } from 'contexts/Features.context';
import { useProfileContext } from 'contexts/UserProfile.context';

const Chatbot = () => {
  const auth = useAuth();
  const { open, setOpen } = useContext(ChatbotContext);
  const { features } = useContext(FeatureFlags);

  const { setInlineFilters } = useInlineFilterContext();
  const { setFiltersOverwrite } = useProfileContext();

  const navigate = useNavigate();

  const handleFilter = (v) => {
    try {
      const decodedValue = decodeURI(v);

      if (
        decodedValue.includes('customerRequestType') &&
        location.pathname !== '/customer-requests'
      ) {
        navigate(`/customer-requests?filters=${v}`);
      }

      const filters = JSON.parse(decodedValue);
      setFiltersOverwrite({ table: 'bySeriesVin' });
      setInlineFilters({ filter: filters?.and?.[0] });
    } catch (error) {
      setInlineFilters({ filter: {} });
    }
  };

  if (!features?.chatbot || !open) return null;

  return (
    <Box
      height="calc(100vh - 6.5rem)"
      ml={-3}
      mt={-3}
      zIndex={999999}
      borderTop="1px solid #E0E0E0"
    >
      <ChatApp
        token={auth?.user?.access_token}
        handleClose={() => setOpen(false)}
        handleFilter={handleFilter}
      />
    </Box>
  );
};

Chatbot.propTypes = {
  setOpen: PropTypes.func.isRequired,
};

export default Chatbot;
